import Img from "@casino/legacyUi/Img";
import getCdnIcon from "@casino/shared/cdn/getCdnIcon";

const DefaultHover: FC = () => (
  <div className="pointer-events-none absolute inset-0 z-3 flex h-full w-full items-center justify-center bg-black/60 opacity-0 transition group-hover:opacity-90">
    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/50 mix-blend-normal backdrop-blur-sm">
      <Img
        width={20}
        height={20}
        alt="play game"
        src={getCdnIcon("play-triangle")}
      />
    </div>
  </div>
);

export default DefaultHover;
